import { escape } from "es-toolkit";

const MARKER = "\x0055";
const REMOVE_MARKERS = new RegExp(`${MARKER}(.*?)${MARKER}`, "gm");

/**
 * helper for bolding a phrase found inside a snippet string
 * see boldify.rb for a similar implementation
 */
export function boldify(str: string, phrase?: string) {
  let s = str;
  if (phrase) {
    const re = RegExp(`\\b${escapeRegExp(phrase)}\\b`, "gi");
    s = s.replace(re, `${MARKER}$&${MARKER}`);
  }
  s = escape(s);
  s = s.replace(REMOVE_MARKERS, "<b>$1</b>");
  return s;
}
